import constants from '../../constants';
import * as Sentry from '@sentry/vue';

export const saveWrap = (actionFn) => {
  return async (vuexProps, payload, { errorMessage } = {}) => {
    let currEditKey;
    const { commit, rootState, dispatch } = vuexProps;
    try {
      commit('editMode/SET_IS_SAVING', true, { root: true });
      currEditKey = rootState.editMode.editKey;
      commit('editMode/UPDATE_SAVE_STATUS', { key: currEditKey, status: true }, { root: true });
      commit('editMode/INCREMENT_EDIT_KEY', null, { root: true });

      const returnedVal = await actionFn(vuexProps, payload);

      commit(
        'editMode/UPDATE_LAST_UPDATED',
        { authorName: rootState.user.firstName + ' ' + rootState.user.lastName },
        { root: true }
      );
      return returnedVal;
    } catch (e) {
      Sentry.captureException(e);
      dispatch(
        'notify',
        { message: errorMessage || 'Something went wrong!', isWarning: true },
        { root: true }
      );
    } finally {
      commit('editMode/UPDATE_SAVE_STATUS', { key: currEditKey, status: false }, { root: true });

      // Prologing the saving indicator by 1 second as per PDD request
      setTimeout(() => {
        commit('editMode/SET_IS_SAVING', false, { root: true });
      }, 1000);
    }
  };
};

export const getKey = (question, questionGroup, character) => {
  if (!question.questionKey) return '';
  const typeId = questionGroup
    ? questionGroup.name
    : constants.QUESTION_TYPES[question.FK_questionDisplayTypeKey].name;
  const characterName =
    character.nameTagKey.split(' ').length === 2
      ? character.nameTagKey.split(' ')[1]
      : character.nameTagKey.split(' ')[0];
  return `${typeId}: ${characterName}_${question.subjectTagKey}`;
};

export const getChartColors = (opacity = 1) => {
  return [
    `rgba(30, 90, 167, ${opacity})`,
    `rgba(247, 143, 69, ${opacity})`,
    `rgba(20, 39, 84, ${opacity})`,
    `rgba(144, 237, 125, ${opacity})`,
    `rgba(234, 67, 72, ${opacity})`,
    `rgba(231, 200, 59, ${opacity})`,
    `rgba(128, 133, 233, ${opacity})`,
    `rgba(139, 208, 207, ${opacity})`,
    `rgba(241, 91, 128, ${opacity})`,
    `rgba(228, 211, 84, ${opacity})`,
    `rgba(0, 108, 255, ${opacity})`,
    `rgba(163, 162, 206, ${opacity})`,
    `rgba(172, 33, 40, ${opacity})`,
    `rgba(251, 241, 152, ${opacity})`,
    `rgba(43, 144, 143, ${opacity})`,
    `rgba(112, 197, 168, ${opacity})`,
    `rgba(124, 181, 236, ${opacity})`,
    `rgba(41, 51, 102, ${opacity})`,
    `rgba(248, 171, 174, ${opacity})`,
    `rgba(128, 167, 191, ${opacity})`,
    `rgba(33, 118, 89, ${opacity})`,
    `rgba(76, 77, 120, ${opacity})`,
    `rgba(253, 249, 219, ${opacity})`,
    `rgba(197, 195, 224, ${opacity})`,
    `rgba(71, 71, 71, ${opacity})`,
    `rgba(178, 222, 209, ${opacity})`,
  ];
};
